import React, { createElement } from 'react';
import './index.css';
import { createRoot } from 'react-dom/client';
import { App } from './App';
// Add font preloading to improve font loading performance
const preloadFonts = () => {
  // Create link for preloading critical fonts with font-display: swap
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap&font-display=swap';
  document.head.appendChild(link);
};
// Add link preconnect for external resources
const addPreconnects = () => {
  const domains = ['https://fonts.googleapis.com', 'https://fonts.gstatic.com', 'https://uploadthingy.s3.us-west-1.amazonaws.com', 'https://images.unsplash.com', 'https://randomuser.me', 'https://img.youtube.com', 'https://www.youtube.com', 'https://www.googletagmanager.com', 'https://connect.facebook.net'];
  domains.forEach(domain => {
    const link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = domain;
    link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
  });
};
// Preload critical hero image and add appropriate resource hints
const optimizeResourceLoading = () => {
  // Preload critical above-the-fold images
  const criticalImages = ['https://uploadthingy.s3.us-west-1.amazonaws.com/8FgGpzRCdDy7ph2WMHyQFS/imgi_32_gempages_581238827771757064-382547a2-553b-49a9-8bda-1929f2a7c35c.webp', 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'];
  criticalImages.forEach(imgSrc => {
    const imgLink = document.createElement('link');
    imgLink.rel = 'preload';
    imgLink.as = 'image';
    imgLink.href = imgSrc;
    document.head.appendChild(imgLink);
  });
  // Add DNS prefetch for third-party domains
  const dnsPrefetchDomains = ['https://www.googletagmanager.com', 'https://connect.facebook.net', 'https://www.youtube.com'];
  dnsPrefetchDomains.forEach(domain => {
    const dnsLink = document.createElement('link');
    dnsLink.rel = 'dns-prefetch';
    dnsLink.href = domain;
    document.head.appendChild(dnsLink);
  });
};
// Execute optimizations before rendering
preloadFonts();
addPreconnects();
optimizeResourceLoading();
// Get the root element
const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}
// Render the app
const root = createRoot(rootElement);
root.render(<App data-id="element-670" />);